import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { ApproveRequest } from '../../types/notification.types';
import { Company } from '../index';
import { useAppQuery } from '../use-app-query.hook';

export const useRequestApproveTasks = ({
  requestId,
  enabled,
}: {
  enabled?: boolean;
  requestId: string;
}) => {
  const { selectedCompanyId: companyId } = Company.useSelected();
  const queryClient = useQueryClient();

  const { data: approvalRequest, isLoading } = useAppQuery<ApproveRequest>({
    queryKey: [QueryKey.GET_REQUESTED_VESTING_TASKS, companyId, requestId],
    queryFn: () =>
      ApiService.get({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'request-approval', requestId],
      }),
    enabled: !!companyId && enabled && !!requestId,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_REQUESTED_VESTING_TASKS] });
  }, [queryClient]);

  return {
    invalidateQuery,
    approvalRequest,
    isLoading,
  };
};
